import cloneDeep from 'lodash/cloneDeep';

class BranchSummary {

  constructor({id, name}) {
    this.id = id;
    this.name = name;
  }

  clone() {
    return cloneDeep(this);
  }

  toApiFormat() {
    return new {
      ID: this.id,
      Name: this.name,
    };
  }

  static fromApiFormat(api) {
    return new BranchSummary({
      id: api.ID,
      name: api.Name,
    });
  }
}

export default BranchSummary;
